import { API_BASE_URL } from "@/config";
import axios from 'axios';
import router from "@/router";

export async function asset_data_retrieval(embedded_data) {
    const BASE_URL = API_BASE_URL;
    const ASSET_API_URL = `${BASE_URL}/verify_api/system_management_api/asset_api/`;

    const response = await axios.post(ASSET_API_URL, { embedded_data });
    const { workflow_name, workflow_id, asset_id, user_id } = response.data.data;
    
    return { workflow_name, workflow_id, asset_id, user_id };
}

export async function anonymous_data_retrieval(embedded_data) {
    const BASE_URL = API_BASE_URL;
    const ANONYMOUS_API_URL = `${BASE_URL}/verify_api/system_management_api/anonymous_data_api/`;

    try {
        const response = await axios.post(ANONYMOUS_API_URL, { 
            embedded_data:embedded_data
        });

        if (response.data.status !== "success") {
            return { error: response.data.message };
        }else {
            const { token, user_id, user_role, client_admin_id, workflow_id } = response.data.data;
            const user_token = token;
            const user_pk = user_id;
            const user_workflow_id = workflow_id;
            return { user_token, user_pk, user_role, client_admin_id, user_workflow_id };
        }
    } catch (error) {
        if (typeof window !== 'undefined') {
            router.push({ name: "invalid_token" });
        }
        return { error: error.response?.data?.error || "Network Error" };
    }
}
